import { PageSizing } from '__components/Layout/PageContentWidth';
import { StyledTwoColumnsRow } from './styles';
import { useTranslation } from 'react-i18next';
import { useContext, useEffect } from 'react';
import { SmartConnectorContext } from '../../context';
import { SmartConnectorType } from 'pages/SmartConnectors/types';
import { SmartConnectorTypeButtons } from './SmartConnectorTypeButtons';
import { CustomObjectSelect } from './CustomObjectSelect';
import { NameInput } from './NameInput';
import { EmailInput } from './EmailInput';
import { StyledCard, StyledLoader, StyledStepHeader } from '../styles';
import { SMART_CONNECTOR_STEPS } from 'pages/SmartConnectors/constants';
import { DiffCheckingSettings } from './DiffCheckingSettings';
import { ApiNameInput } from 'pages/SmartConnectors/components/ApiNameInput';
import { WithMobileWarning } from 'pages/SmartConnectors/components/WithMobileWarning';

export const GeneralSettingsStep = () => {
  const { t } = useTranslation();
  const { smartConnector, stepData, setStepData, setIsValid, loading } =
    useContext(SmartConnectorContext);

  useEffect(() => {
    setIsValid(true);
  }, [setIsValid]);

  const handleChangeName = (value: string) => {
    setStepData((prev) => ({ ...prev, name: value }));
  };

  const handleChangeErrorEmail = (value: string) => {
    setStepData((prev) => ({ ...prev, error_notification_email: value }));
  };

  const handleChangeAllEmail = (value: string) => {
    setStepData((prev) => ({ ...prev, all_notification_email: value }));
  };

  const handleChangeConnectorType = ({
    value,
  }: {
    value: SmartConnectorType;
  }) => {
    // we do not support connector types other than spreadsheet
    //setStepData((prev) => ({ ...prev, connector_type: value }));
  };

  const handleChangeObject = (value: string) => {
    setStepData((prev) => ({ ...prev, custom_object: value }));
  };

  return (
    <WithMobileWarning>
      <PageSizing>
        <StyledCard data-qa={`${SMART_CONNECTOR_STEPS.general}-step`}>
          <StyledStepHeader type="subheader">
            {t('General Settings')}
          </StyledStepHeader>
          <StyledLoader loading={loading}>
            <StyledTwoColumnsRow>
              <NameInput value={stepData.name} onChange={handleChangeName} />
              <ApiNameInput value={stepData.api_name} />
            </StyledTwoColumnsRow>
            <SmartConnectorTypeButtons
              value={stepData.connector_type!}
              onChange={handleChangeConnectorType}
            />
            <StyledTwoColumnsRow>
              <CustomObjectSelect
                value={stepData.custom_object!}
                onChange={handleChangeObject}
                disabled={!!smartConnector.id}
              />
              <EmailInput
                name="all_notification_email"
                value={stepData.all_notification_email}
                label={t('Additional Notification Email')}
                labelInfo={t(
                  'Notification emails will always be sent to the uploading user by default, but you may also add another email recipient. This address will receive both Success and Error notifications.'
                )}
                onChange={handleChangeAllEmail}
              />
            </StyledTwoColumnsRow>
            <StyledTwoColumnsRow>
              <DiffCheckingSettings />
              <EmailInput
                name="error_notification_email"
                value={stepData.error_notification_email}
                label={t('Additional Error Notification Email')}
                labelInfo={t(
                  'Error emails will always be sent to the uploading user by default, but you may also add another email recipient (such as a distribution group).'
                )}
                onChange={handleChangeErrorEmail}
              />
            </StyledTwoColumnsRow>
          </StyledLoader>
        </StyledCard>
      </PageSizing>
    </WithMobileWarning>
  );
};
